export enum WeightedReturnType {
  MONEY_WEIGHTED = 'MONEY_WEIGHTED',
  TIME_WEIGHTED = 'TIME_WEIGHTED'
}

